<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ $t("blockCompany") }}
      </p>
    </header>
    <section class="modal-card-body">
      <div>
        <b-field :label="$t('legalName')">
          <b-input v-model="legalName" :placeholder="$t('legalName')" />
        </b-field>
        <b-field :label="$t('vatId')">
          <b-input v-model="vatId" :placeholder="$t('vatId')" />
        </b-field>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        {{ $t("close") }}
      </button>
      <button class="button is-primary" @click="addToBlacklist">
        {{ $t("confirm") }}
      </button>
    </footer>
  </div>
</template>

<script>
//import { functions } from "@/firebase"
export default {
  name: "BlacklistModal",
  props: {
    blacklistCollection: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      legalName: "",
      vatId: "",
      isLoading: false,
    };
  },
  watch: {
    vatId() {
      this.vatId = this.vatId.replace(/\s/g, "");
    },
  },
  methods: {
    addToBlacklist() {
      this.blacklistCollection
        .add({
          name: this.legalName,
          blockDate: new Date(),
          vatId: this.vatId,
        })
        .then(() => {
          this.$buefy.toast.open({
            message: this.$t("blacklistAdded"),
            type: "is-success",
          });
        })
        .catch((error) => {
          this.$buefy.toast.open({
            message: `ERROR: ${error.getMessage()}`,
            type: "is-danger",
          });
        })
        .finally(() => {
          this.$parent.close();
        });
    },
  },
};
</script>
